import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Button, Tooltip } from 'react-wot-bootstrap'

import {
    ANNOUNCEMENT_CREATE_BUTTON_SAVE,
    ANNOUNCEMENT_EDIT_BUTTON_SAVE,
    ANNOUNCEMENT_EDIT_BUTTON_CANCEL,
    ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_LIMIT,
    ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_FORBIDDEN,
} from '../../translations'

import { TOOLTIP_IDS, ANNOUNCEMENT_MODE, FOOTER_EDIT_CONTROLS_STATE } from '../../constants'

import styles from './Footer.scss'

const getSavingButtonTooltip = (state) => {
    switch (state) {
    case FOOTER_EDIT_CONTROLS_STATE.MAX_CHARS:
        return ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_LIMIT
    case FOOTER_EDIT_CONTROLS_STATE.FORBIDDEN_WORDS:
        return ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_FORBIDDEN
    default:
        return ''
    }
}

export const FooterEditControls = (props) => {
    const { announcementMode, state, onSave, onCancel } = props

    const isCreating = announcementMode === ANNOUNCEMENT_MODE.CREATE
    const isDisabledSaving = state !== FOOTER_EDIT_CONTROLS_STATE.WITHOUT_RESTRICTION

    const savingButtonTooltip = getSavingButtonTooltip(state)

    const savingButtonText = isCreating ?
        ANNOUNCEMENT_CREATE_BUTTON_SAVE :
        ANNOUNCEMENT_EDIT_BUTTON_SAVE

    const baseClassNames = classNames(
        styles.base,
        styles.base__edit,
    )

    return (
        <div className={baseClassNames}>
            <div className={styles.button}>
                <Button
                    isDisabled={isDisabledSaving}
                    tooltipId={TOOLTIP_IDS.BUTTON_SAVE}
                    onClick={() => onSave(ANNOUNCEMENT_MODE.CREATE)}
                >
                    <span className={styles.buttonText}>
                        {savingButtonText}
                    </span>
                </Button>
                {savingButtonTooltip && (
                    <Tooltip id={TOOLTIP_IDS.BUTTON_SAVE}>
                        {savingButtonTooltip}
                    </Tooltip>
                )}
            </div>
            <div className={styles.button}>
                <Button
                    type={'secondary'}
                    onClick={onCancel}
                >
                    <span className={styles.buttonText}>
                        {ANNOUNCEMENT_EDIT_BUTTON_CANCEL}
                    </span>
                </Button>
            </div>
        </div>
    )
}

FooterEditControls.propTypes = {
    announcementMode: PropTypes.oneOf(Object.values(ANNOUNCEMENT_MODE)).isRequired,
    state: PropTypes.oneOf(Object.values(FOOTER_EDIT_CONTROLS_STATE)).isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/components/Footer/FooterEditControls.jsx